import React, { JSX } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryLoadingAbsolute } from '@ankr.com/raas-ui';
import { i18n } from '@ankr.com/raas-utils';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { HOMEPAGE } from './modules/common/const/values';
import { AppBase } from './modules/layout/components/AppBase';
import { BreadcrumbsProvider } from './modules/layout/components/Breadcrumbs';
import { AppRoutes } from './Routes';
import { persistor, store } from './store';

function App(): JSX.Element {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <PersistGate loading={<QueryLoadingAbsolute />} persistor={persistor}>
          <BrowserRouter basename={HOMEPAGE}>
            <QueryParamProvider adapter={ReactRouter6Adapter}>
              <AppBase>
                <BreadcrumbsProvider>
                  <AppRoutes />
                </BreadcrumbsProvider>
              </AppBase>
            </QueryParamProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </I18nextProvider>
  );
}

export default App;
